import { Button, Grid, Group, Layout, Text } from "@/comn/components";
import { useFetch, useGrid, useModal, useStore, useToast } from "@/comn/hooks";
import { comnUtils } from "@/comn/utils";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { APIS, SG_COMN_CD_MGMT_DTL_LIST, URLS } from "./services/OsciComnCdAppService";
import { Link } from "react-router-dom";

/*
 * Common Code Valid Values List
 * !== 공통 코드 유효 값 목록 ==!
 */
export const OSCI0109005Q = (props: any) => {
    const pgeUid = "UI-OSCI-0109-005Q";
    const { t } = useTranslation();
    const modal = useModal();
    const toast = useToast();
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid });
    const { comnCd } = useParams();

    const grid = {
        comnCdMgmtDtlList: useGrid({
            defaultSchema: SG_COMN_CD_MGMT_DTL_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const fetch = {
        // Check Common Code Valid Values List !== 공통 코드 유효 값 목록 조회 ==!
        getComnCdDtlList: useFetch({
            api: (page = grid.comnCdMgmtDtlList.page) =>
                APIS.getComnCdDtlList(comnCd, page, grid.comnCdMgmtDtlList.size),
            enabled: !!comnCd,
            key: [grid.comnCdMgmtDtlList.page, grid.comnCdMgmtDtlList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    page: grid.comnCdMgmtDtlList.page,
                    size: grid.comnCdMgmtDtlList.size,
                });
            },
            onError: () => toast.showToast({ type: "error", content: "msg.osc.00043" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
        // Delete Common Code Valid Values !== 공통 코드 유효 값 삭제 ==!
        deleteComnCdDtl: useFetch({
            api: (cdVldVals) => APIS.deleteComnCdDtl(comnCd, cdVldVals),
            onSuccess: () => {
                modal.openModal({
                    content: "msg.osc.00071", // Successfully removed. !== 정상적으로 삭제되었습니다. ==!
                });
                handler.getComnCdDtlList();
            },
            onError: () => toast.showToast({ type: "error", content: "msg.osc.00040" }), // Failed to remove. !== 삭제가 실패하였습니다. ==!
            showToast: true,
        }),
    };

    const handler = {
        // Check Common Code Valid Values List !== 공통 코드 유효 값 목록 조회 ==!
        getComnCdDtlList: () => {
            grid.comnCdMgmtDtlList.setPage(0);
            fetch.getComnCdDtlList.fetch(0);
        },

        // Delete Common Code Valid Values !== 공통 코드 유효 값 삭제 ==!
        deleteComnCdDtl: (data: any) => {
            fetch.deleteComnCdDtl.fetch(data);
        },
        // Add Grid button !== 그리드 추가 버튼 ==!
        click_Btn_Add: () => {
            modal.openModal({
                url: URLS.osci0109006s + "/" + comnCd,
                size: "md",
                draggable: true,
                callback: (data) => {
                    if (data.pgeUid == "UI-OSCI-0109-006S") {
                        modal.closeModal();
                    }
                    handler.getComnCdDtlList();
                },
            });
        },
        // Delete Grid button !== 그리드 삭제 버튼 ==!
        click_Btn_Del: () => {
            const list: any[] = grid.comnCdMgmtDtlList.getChecked() || [];
            if (comnUtils.isEmpty(list)) {
                modal.openModal({ content: "msg.osc.00084" }); // No data has been selected. !== 선택된 데이터가 없습니다. ==!
                return;
            }
            modal.openModal({
                content: "msg.osc.00062", // Confirm remove? !== 삭제하시겠습니까? ==!
                onConfirm: () => {
                    const cdVldVals: string[] = [];
                    list.forEach((item) => {
                        cdVldVals.push(`${item.cdVldVal}`);
                    });
                    handler.deleteComnCdDtl(cdVldVals.join(","));
                },
            });
        },
    };
    const render = {
        comnCdMgmtDtlList: {
            head: {},
            cell: {
                cdVldVal: (props: any) => {
                    const { rowValues } = props;
                    return (
                        <Link
                            to={"#"}
                            onClick={(e) => {
                                e.preventDefault();
                                modal.openModal({
                                    url: URLS.osci0109007q + "/" + comnCd + "/" + rowValues.cdVldVal,
                                    size: "md",
                                    draggable: true,
                                    callback: (data) => {
                                        if (data.pgeUid == "UI-OSCI-0109-007Q") {
                                            modal.closeModal();
                                        }
                                        handler.getComnCdDtlList();
                                    },
                                });
                            }}
                        >
                            {rowValues.cdVldVal}
                        </Link>
                    );
                },
            },
        },
    };

    useEffect(() => {
        handler.getComnCdDtlList();
    }, []);

    return (
        <Group>
            <Group.Body>
                <Group.Section>
                    <Layout gap={4} direction="col">
                        <Layout direction="row">
                            <Layout.Right>
                                <Button
                                    variant="outline-primary"
                                    onClick={() => {
                                        handler.click_Btn_Add();
                                    }}
                                >
                                    {t("B_ADD")}
                                </Button>
                                <Button
                                    variant="outline-danger"
                                    onClick={() => {
                                        handler.click_Btn_Del();
                                    }}
                                >
                                    {t("B_DEL")}
                                </Button>
                            </Layout.Right>
                        </Layout>
                        <Grid
                            {...grid.comnCdMgmtDtlList.grid}
                            data={fetch.getComnCdDtlList.data?.comnCdDtlList}
                            render={render.comnCdMgmtDtlList}
                        />
                    </Layout>
                </Group.Section>
            </Group.Body>
        </Group>
    );
};
